import {JobRun} from './utilTypes';

// Return true if the job that created a run has the specified alias.
export const hasJobAlias = (run: JobRun, alias: string): boolean => {
  for (const jobAlias of run.jobAliases) {
    if (jobAlias.alias === alias) {
      return true;
    }
  }
  return false;
};
